
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.43 26.716"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_29409","data-name":"Group 29409","transform":"translate(-377.018 -794.472)"}},[_c('path',{attrs:{"id":"Path_6516","data-name":"Path 6516","d":"M392.4 872.2v-6.258h-5.628v4.678H384.4a7.346 7.346 0 00-3.328.792 7.377 7.377 0 003.328 13.959h.631A7.376 7.376 0 00392.4 878v-5.8z","transform":"translate(0 -64.185)","fill":"#1ccdfd"}}),_c('path',{attrs:{"id":"Path_6517","data-name":"Path 6517","d":"M424.738 794.472h-.631a7.376 7.376 0 00-7.375 7.377V813.9h5.628v-4.678h2.378a7.342 7.342 0 003.328-.792 7.376 7.376 0 00-3.329-13.959z","transform":"translate(-35.665)","fill":"#c458fb"}}),_c('g',{attrs:{"id":"Group_19420","data-name":"Group 19420","transform":"translate(381.067 801.758)"}},[_c('g',{attrs:{"id":"Group_19423","data-name":"Group 19423"}},[_c('g',{attrs:{"id":"Group_19421","data-name":"Group 19421"}},[_c('path',{attrs:{"id":"Path_6512","data-name":"Path 6512","d":"M422.438 865.943v4.678h-2.378a7.346 7.346 0 00-3.328.792v6.674h5.628v-4.678h2.378a7.345 7.345 0 003.328-.793v-6.673z","transform":"translate(-416.732 -865.943)","fill":"#854cf9"}})])])])])])
          )
        }
      }
    